import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'statusHumanize' })
export class StatusHumanizePipe implements PipeTransform {
  transform(value?: string | null): string {
    if (!value) return '';
    return String(value).replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }
}


